import React, { useEffect } from 'react';
import ManagementPolicyPageMain from '../../presentation/section/footer-link-page/ManagementPolicyPageMain';

const ManagementPolicy = (props) => {
  useEffect(() => {
    window.scrollTo(0,0)
  }, [])

  return (
    <ManagementPolicyPageMain />
  )
}

export default ManagementPolicy;